var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiramide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 702,
    height: 541,
    viewBox: "0 0 702 541",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M607.632 406.5L692.631 538.57H2.74902L87.7385 406.5H607.632Z",
    stroke: "#09A783",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M605.781 403.58H89.7489L174.739 271.5H520.791L605.781 403.58Z",
    stroke: "#00CDEA",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M518.931 268.58H176.749L261.739 136.5H433.941L518.931 268.58Z",
    stroke: "#8F65CD",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M408.779 97.3219L432.102 133.59H263.749L347.92 2.7718L408.778 97.3213L408.779 97.3219Z",
    stroke: "#FF7F41",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiramide);
export default __webpack_public_path__ + "static/media/piramide.f02768c183799e0351019678784f6bf9.svg";
export { ForwardRef as ReactComponent };